<template>
  <div class="sidebar-wrap">
    <template v-for="(item,num) in routes">
      <!-- 单级 -->
      <!-- <router-link
        v-if="onlyOneShowingChildren(item.children) &&
          !item.children[0].children &&
          !item.alwaysShow"
        :key="item.children[0].name"
        :to="item.path+'/'+item.children[0].path">
        <el-menu-item :index="item.path + '/' + item.children[0].path">
          icon
          <icon
            v-if="item.children[0].meta && item.children[0].meta.icon"
            :name="item.children[0].meta.icon"
            :scale="2">
          </icon>
          侧边栏标题
          <span slot="title"
            v-if="item.children[0].meta && item.children[0].meta.title">
            {{getTitle(item.children[0].meta.title)}}
          </span>
        </el-menu-item>
      </router-link>-->
      <!-- 一级菜单 -->
      <el-submenu
          v-if="item.id!=415"
          :class="{'sidebar-wrap__menu':true,'activeTit':item.menuName == tit}"
          :key="item.menuName"
          :index="item.menuName || item.id"
      >
        <template slot="title">
          <!-- <icon
            v-if="item.meta && item.meta.icon"
            :name="item.meta.icon"
            :scale="2">
          </icon>-->
          <!-- <icon
                :name="iconArr[num]"
                :scale="2">
          </icon>-->
          <span :class="'iconfont '+iconArr[num]" style="font-size:16px;"></span>
          <span
              slot="title"
              v-if="item.menuName && item.id"
              style="color:rgba(255,255,255,0.8)"
          >{{ sliderState === 'full' ? getTitle(item.menuName) : '' }}</span>
        </template>
        <template v-for="child in item.libList">
          <!-- 二级菜单 -->

          <!-- 420: 重点道路统计 -->
          <sidebar-item
              v-if="child.libList && child.libList.length > 0 && (child.id == 414||child.id ==624||child.id ==701||child.id ==702||child.id ==703||child.id ==705||child.id ==706||child.id ==707)"
              :routes="[child]"
              :key="child.id"
          ></sidebar-item>
          <router-link
              v-else
              :to="userType!=2?allRouter[child.id].path
                  :allRouter[child.id].path_district?allRouter[child.id].path_district+'?provinceName='+areaList[0].provinceName+'&provinceCode='+areaList[0].provinceCode
                  :allRouter[child.id].path"
              :key="child.id"
              @click.native="changeActive(child.id)"
          >
            <el-menu-item
                v-if="showMenuItem(child)"
                :index="child.menuName"
                :class="{'item-style':allRouter[child.id].isActive}"
            >
              <!-- <icon
                :name="iconArr[index+num]"
                :scale="2">
              </icon>-->
              <span
                  slot="title"
                  v-if="child.menuName"
                  style="color:rgba(255,255,255,0.8)"
              >{{ getTitle(child.menuName) }}</span>
            </el-menu-item>
          </router-link>
        </template>
      </el-submenu>
    </template>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import http from '@/api/click.js' //请求汇总
import allRouter from './allRouter'

export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: [Array, Object, String]
    },
    userType: {
      type: String
    },
    tit: {
      type: String
    },
    areaList: {
      type: [Array, Object, String]
    },
  },
  data() {
    return {
      allRouter,
      iconArr: [
        'icon-iconfontmingpian',
        'icon-gaojingxinxi',
        'icon-xiaofei',
        'icon-huoyun',
        'icon-yunying'
      ],
      name: false
    }
  },
  watch: {
    tit: function (value, oldValue) {
      // console.log(value)
    }
  },
  mounted() {
    // console.log(this.routes);
    // console.log(this.userType);
    // console.log(this.areaList);
  },
  computed: {
    sliderState() {
      return this.$store.getters.sidebar.sliderState
    },
    showMenuItem() {
      return function (menuItem) {
        if (1 == menuItem.type) {
          // // 仅石化总部和中交兴路用户可见。即：仅仅userType=0或3的用户可以看到这两个周菜单
          // if(["/weeklyCarOperate","/weeklyBrandGas"].includes(menuItem.pageUrl) && (this.userType != 0 && this.userType != 3) ){
          //   return false;
          // }
          return true;
        } else {
          return false
        }
      }
    }
  },
  methods: {
    onlyOneShowingChildren(children) {
      return children.filter(item => !item.hidden).length === 1
    },
    //国际化
    getTitle(title) {
      if (this.$te(`route.${title}`)) {
        return this.$t(`route.${title}`)
      }
      return title
    },
    changeActive(id) {
      let phone = Cookies.get('user')
      http.click({menuId: id, phone})
      let arr = Object.assign({}, this.allRouter)
      for (let i in this.allRouter) {
        this.allRouter[i].isActive = false
      }
      this.allRouter[id].isActive = true
    }
  }
}
</script>

<style lang="stylus">
.sidebar-wrap__menu {
  color: rgba(255, 255, 255, 0.8);
}

#app .el-submenu .el-menu-item {
  color: rgba(255, 255, 255, 0.8);
}

.el-submenu.is-opened.sidebar-wrap__menu.activeTit > .el-submenu__title {
  background-color: #336db0 !important;
}

#app .el-submenu .el-menu-item:hover {
  background-color: rgba(24, 83, 137, 0.8) !important;
}

.sidebar-wrap {
  .el-submenu, .el-menu-item {
    font-size: 0;

  // background-color #2E303C!important

    svg {
      margin-right: 17px;
    }

    span {
      font-size: 14px;
    }
  }

  .svg-icon {
    fill: currentColor;
  }
}

#app .el-submenu .el-menu-item.is-active {
  color: rgba(255, 255, 255, 1);
  background: #20232B;
}

.item-style {
  color: rgba(255, 255, 255, 1) !important;
  background-color: rgba(24, 83, 137, 0.8) !important;
}
</style>
